import {apiRetrieve} from "../api.ts";

/**
 * Google sign-in for funnel pages (quiz, from-generator, …).
 *
 * OAuth is a full-page redirect: the user leaves for Google, and the backend callback drops them on
 * /login/jwt-redirect/?token=… — which by default routes to the profile/sport-area home, losing the
 * funnel. So before redirecting we stash the funnel's return path in sessionStorage (survives the
 * round-trip, per-tab), and LoginView's jwt-redirect handler navigates there instead.
 *
 * The caller is responsible for stashing its own flow state (e.g. the generator handoff) first.
 */
export const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';

export function startGoogleSignIn(returnTo: string) {
    try {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, returnTo);
    } catch {
        // storage unavailable — worst case the user lands on their profile, still signed in
    }
    apiRetrieve('socialite/google/url').then((r: any) => {
        if (r?.url) document.location.href = r.url;
    });
}

/**
 * Read-and-clear the stashed return path (used by LoginView's jwt-redirect handler).
 *
 * Remembers what it consumed for a short window so React StrictMode's dev double-mount (both
 * effect runs calling this) gets the same answer twice — otherwise the second run sees an empty
 * stash, falls through to the default destination, and overrides the funnel navigation.
 */
let lastConsumed: {value: string, at: number} | null = null;

export function consumePostLoginRedirect(): string | null {
    try {
        const v = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
        if (v) {
            sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
            lastConsumed = {value: v, at: Date.now()};
            return v;
        }
        if (lastConsumed && Date.now() - lastConsumed.at < 10_000) {
            return lastConsumed.value;
        }
        return null;
    } catch {
        return null;
    }
}
